import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderBar from "Portal/NewPortal/HeaderBar/View";
import FlyOver from "./FlyOver";
import Loading from "components/Global/Loading";
import MobileFooter from "Portal/NewPortal/MobileFooter";
import { Mobile } from "Portal/NewPortal/Shared/MediasQuery";

import { getters, actions } from "../model";

import styles from "./styles.scss";

const decorate = connect(
  state => ({
    loading: getters.loading(state)
  }),
  {
    init: actions.init
  }
);

const Layout = ({ init, children, loading = true }) => {
  useEffect(() => {
    init();
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.close();
    }
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%"
        }}
      >
        <Loading className={styles.loading} content="Loading Portal..." />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%"
      }}
    >
      {children}
      <HeaderBar />
      <FlyOver />
      <Mobile>
        <MobileFooter />
      </Mobile>
    </div>
  );
};

export default decorate(Layout);
